import * as React from 'react';
import { Title } from '../title';
import { ClickElement } from '../form';
import { userLogout } from '../../apis/user';
import { STEMINTRODUCTION } from '../../lib/labels';

export const StemIntroduction = ({ username, setShowIntro }) => {
  return(
    <>
      <Title Tag='h2'>
        {STEMINTRODUCTION.TITLE}
      </Title>
      <h1>Hoi <span style={{ 'color': '#66cc22' }}>{username}</span></h1>
      <ClickElement
        tertiary
        ElementType="a"
        type="button"
        text={STEMINTRODUCTION.BUTTON_LOGOUT}
        href={userLogout()}
        rel="noopener noreferrer"
      />      
      <p dangerouslySetInnerHTML={{ __html: STEMINTRODUCTION.INTRO_TEXT }} />
      <ClickElement
        ElementType="button"
        text={STEMINTRODUCTION.BUTTON_CONTINUE}
        onClick={() => setShowIntro(false)}
        primary
      />
    </>
  );
};